import {
    inWord,
    goToNextWord} from './word.js';
import {getStepsAtStepNumber} from './step.js';
import {goToStartOfLine} from './line.js';
import {deleteStepNumber} from 'operations/actions.js';
import {deleteSteps} from 'operations/actions.js';

const MAX_HOPS = 500;

export function deleteAtCursor(sequencerEngine) {
    let track = sequencerEngine.getSelectedTrack();
    if (inWord(sequencerEngine)) {
        let stepData = sequencerEngine.getSelectedStepData();
        let stepNumber = sequencerEngine.cursor.step;
        let copied = getCopyOfSteps([{stepNumber: stepNumber, step: stepData}]);
        let stepsDeleted = sequencerEngine.operationManager
            .dispatch(deleteStepNumber(track, stepNumber));
        return copied;
    }
    return [];
}

export function deleteNextWord(sequencerEngine, deleteTheSteps=true) {
    if (!inWord(sequencerEngine)) {
        goToNextWord(sequencerEngine);
    } 

    let track = sequencerEngine.getSelectedTrack();
    let p = track.getEasyPattern();
    let steps = [];
    let visited = new Set();
    let counter=0;
    while (inWord(sequencerEngine)) {
        counter++;
        // ensure we haven't visited this step already
        // to avoid infinite loop
        let step = sequencerEngine.getSelectedStepData();
        if (visited.has(step) || counter > MAX_HOPS) {
            return;
        }
        visited.add(step);

        // find all steps the are "on"
        let stepNumber = sequencerEngine.cursor.getStep(sequencerEngine.resolution);
        let stepsAtStepNumber = p.getStepsAtStepNumber(
            stepNumber, sequencerEngine.resolution)
            .map(s => ({
                ... s,
                stepNumber: sequencerEngine.cursor.step
            }));

        steps = [... steps, ...stepsAtStepNumber];
        sequencerEngine.right();
    }

    // make copy (so we can paste it later)
    let copiedSteps = getCopyOfSteps(steps);

    if (deleteTheSteps) {
        // delete "on" steps we've found
        sequencerEngine.operationManager
            .dispatch(deleteSteps(track, steps.map(x => x.step)));
    }

    return copiedSteps;
}

export function deleteLine(sequencerEngine, deleteTheSteps=true) {
    goToStartOfLine(sequencerEngine);
    let numSteps = sequencerEngine.resolution.numSteps();
    let baseStepsPerStep = sequencerEngine.resolution.getNumberOfStepsAtBaseResolution();
    let steps = [];
    let track = sequencerEngine.getSelectedTrack();
    let p = track.getEasyPattern();

    let stepNumber = sequencerEngine.cursor.step;
    for (let i=0; i < numSteps; i++) {
        let stepNumbers = p.getStepsAtStepNumber(stepNumber)
            .map(s => ({
                ... s,
                stepNumber: stepNumber,
            }));

        steps = [... steps, ...stepNumbers];
        stepNumber += baseStepsPerStep;
    }

    // make copy (so we can paste it later)
    let copiedSteps = getCopyOfSteps(steps);

    if (deleteTheSteps) {
        sequencerEngine.operationManager
            .dispatch(deleteSteps(track, steps.map(x => x.step)));
    }
    return copiedSteps;
}

function getCopyOfSteps(stepInfos) {
    let copied = [];
    for (let i in stepInfos) {
        copied.push({
            ... stepInfos[i],
            step: stepInfos[i].step.getCopy(true, false, true, false, false)
        });
    }
    return copied;
}
